import lodash from 'lodash'

import { request } from '../../../1stlog-ui/src/utils'

export async function requestRoots({ mode }) {
  const { data } = await request({
    method: 'post',
    url: `/api/ztn/roots/${mode}`
  })
  return data
}

export async function requestSearch({ mode, query }) {
  const { data } = await request({
    method: 'post',
    url: `/api/ztn/search/${mode}`,
    data: { query }
  })
  return data
}

export async function requestById({ mode, id }) {
  const { data } = await request({
    method: 'post',
    url: `/api/ztn/byId/${mode}`,
    data: { id }
  })
  return data
}
